<template>
  <fragment>
    <t-dialog ref="dialog" dense light :fullscreen="$forSize['phone-only']" :beforeClose="() => clearData()">
      <template v-slot:text>
        <div class="dialog-content">
          <template v-if='loading'>
            <div class='spinner-container'>
              <t-spinner />
            </div>
          </template>
          <template v-if='!codeActivated'>
            <h3 class='dialog-title' v-html="$config.strings['accessCode-title']" />
            <div class="form-field">
              <span class='input-label' v-html="$config.strings['accessCode-formField-name']" />
              <t-input
                name='userCode'
                inputClasses='custom-input'

                v-model='userCode'
              />
              <span v-if='errorOnActivate' class='input-error' v-html='errorMsg' />
            </div>
            <t-button :size="'lg'" @click="submitCode" :backgroundColor="$config.colors.secondary" :color="$config.colors.on.secondary" v-html="$config.strings['accessCode-btn']" />
          </template>
          <template v-else>
            <div class='success'>
              <h3 v-html="$config.strings['accessCode-success']" />
              <t-button :size='"lg"' :backgroundColor="$config.colors.secondary" :color="$config.colors.on.secondary" v-html="$config.strings['accessCode-success-btn']" @click="loginRedirect" />
            </div>
          </template>
        </div>
      </template>
    </t-dialog>
  </fragment>
</template>

<script>
import { mapActions } from 'vuex'
import { TDialog, TButton, TInput, TSpinner } from '@/components/base'

export default {
  name: 'dialog-access-by-code',
  components: { TDialog, TButton, TInput, TSpinner },
  data () {
    return {
      codeActivated: false,
      userCode: '',
      errorOnActivate: false,
      errorMsg: '',
      loading: false
    }
  },
  mounted () {
    this.$events.$on('OPEN-ACCESS-CODE-MODAL', () => {
      this.$refs.dialog.open()
    })
  },
  beforeUpdate () {
    console.log('This.errorMsg: ', this.errorMsg)
  },
  beforeDestroy () {
    this.clearData()
    this.$events.$off('CLOSE-ACCESS-CODE-MODAL')
  },
  methods: {
    ...mapActions(['activateAccessCode']),
    loginRedirect () {
      location.href = this.$config.urls.login_url
    },
    onSuccessActivate (response) {
      const { data: { status } } = response
      if (status === 'PROCESSADO') {
        this.codeActivated = true
        this.loading = false
      } else {
        this.onFailActivate(response)
      }
    },
    onFailActivate (response) {
      const { data: { description } } = response
      this.errorOnActivate = true
      this.errorMsg = !description ? this.$config.strings['accessCode-error'] : description
      this.loading = false
    },
    submitCode () {
      this.loading = true
      this.errorOnActivate = false
      if (this.userCode === '' || this.userCode === ' ') {
        this.loading = false
        this.errorOnActivate = true
        this.errorMsg = 'É preciso informar um código antes de continuar.'
        return null
      }
      this.activateAccessCode({ 'CodigoDeAcesso': this.userCode }).then(this.onSuccessActivate, this.onFailActivate)
    },
    clearData () {
      this.codeActivated = false
      this.userCode = ''
      this.errorOnActivate = false
      this.errorMsg = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 15px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  position: relative;

  .dialog-title {
    padding-bottom: 32px;

    @include for-size(desktop-up) {
      font-size: 24px;
    }
  }

  @include for-size(desktop-up) {
    padding: 0 75px 40px 63px;
  }

  .spinner-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 1;

    > svg {
      margin-top: -50px
    }
  }

  .form-field {
    width: 100%;

    .input-label {
      font-size: 18px;
      font-weight: 600;
    }

    .input-error {
      position: relative;
      display: block;
      margin-top: -5px;
      padding-bottom: 10px;
      color: crimson;
      font-size: 14px;
    }
  }

  .success {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    > h3 {
      font-size: 32px;
      padding-bottom: 24px;
    }
  }

}
</style>

<style lang='scss'>
  .custom-input {
    border: 1px solid black !important;
  }
</style>
